<template>
  <p class="has-text-start mt-2">
    <a v-if="status && !onlyIcon" class="button is-static">{{ status }}</a>
    <a v-else @click.prevent="geolocate()" class="button p-0"  href="#">
      <img v-if="showIcon && !onlyIcon" class="location-svg pr-2" src="@/images/header/crosshairs-gps.svg" alt="Use current location">
      <span v-if="!onlyIcon" class="main-txt">Use my current location</span>
      <button v-if="onlyIcon" @click="geolocate()" class=" flex justify-center items-center">
        <img 
          :class="[iconHeight ? `${iconHeight}` : 'h-7']"
          src="@/images/location.svg" 
          alt="Location icon"
        >
      </button>
    </a>
  </p>
</template>

<script>
export default {
  data () {
    return {
      status: null
    }
  },
  props: {
    showIcon: {
      default: true,
      required: false,
      type: Boolean
    },
    onlyIcon: {
      default: false,
      required: false,
      type: Boolean
    },
    iconHeight: {
      required: false,
      type: String
    }
  },
  methods: {
    geolocate () {
      if (!navigator.geolocation) {
        this.status = 'Geolocation is not supported by your browser.'
      } else {
        this.status = 'Locating…'
        navigator.geolocation.getCurrentPosition(this.onSuccess, this.onError)
      }
    },
    onSuccess (position) {
      this.$emit('success', {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      })
      this.status = ''
    },
    onError () {
      this.status = 'Unable to retrieve your location…'
    }
  }
}
</script>

<style scoped lang="scss">
.location-svg {
  filter: invert(100%) brightness(100%) saturate(0%);
  width: 25px;
  height: 25px;
}
.main-txt {
  font-size: 12px;
}
.button {
  background: transparent;
  border: 0;
  color: inherit;
  &.is-static {
    background-color: transparent;
    border-color: transparent;
    color: #fff;
  }
  &:hover {
    color: inherit;
    text-decoration: underline;
  }
  span {
    color: inherit;
  }
  .icon {
    width: 1em !important;
    height: 1em !important;
    color: inherit;
  }
}
</style>
